import { FormState, FormValidationFunction } from '@Shared/Components/Forms/FormElement.types'

export const MinLengthValidation: (length: number) => FormValidationFunction<unknown> = length => (value, t) => {
  if (`${value}`.length >= length) {
    return { state: FormState.VALID }
  }
  return {
    message: t('checkout:COF_WE_NEED_THIS_FIELD_TOO'),
    state: FormState.ERROR,
  }
}
